/** Client-side totals for ACE structured quotation (matches backend computeStructuredQuotationTotals). */

import toOptNumber from "./toOptNumber";

const STRUCTURED_AMOUNT_KEYS = [
  "transportationChargesAmount",
  "carTransportationChargesAmount",
  "loadingChargesAmount",
  "unloadingChargesAmount",
  "unpackingRearrangingChargesAmount",
  "shuttleLongCarryEscortChargesAmount",
  "carrierRiskChargesAmount",
];

export function sumStructuredLineAmounts(doc) {
  let s = 0;
  const o = doc || {};
  for (const k of STRUCTURED_AMOUNT_KEYS) {
    const n = toOptNumber(o[k]);
    if (n != null && n >= 0) s += n;
  }
  return Math.round(s * 100) / 100;
}

export function computeAceQuotationTotals(doc) {
  const sub = sumStructuredLineAmounts(doc);
  const gAmtRaw = toOptNumber(doc.gstAmount);
  const gPct = toOptNumber(doc.gstPercent);
  let gst = 0;
  if (gAmtRaw != null && gAmtRaw >= 0) gst = Math.round(gAmtRaw * 100) / 100;
  else if (gPct != null && gPct > 0) gst = Math.round(sub * (gPct / 100) * 100) / 100;
  const total = Math.round((sub + gst) * 100) / 100;
  return { subTotal: sub, gstAmount: gst, totalAmount: total };
}
